<div class="picklist-list-item__wrapper p-5">
  <div class="flex gap-4">
    <div class="flex grow flex-column gap-4">
      <div class="flex gap-2">
        <div class="grow">
          <h3>Credit Memo Details</h3>
        </div>
      </div>
    </div>
  </div>
  <mat-card class="lum-mat-card">
    <mat-card-content>
      <div class="flex gap-4">
        <div class="flex grow flex-column gap-4">
          <div class="flex gap-2">
            <div class="grow">
              <div class="lum-label">Label</div>
              <div class="flex">{{ creditMemoDetails?.label }}</div>
            </div>
          </div>
        </div>
        <div class="flex grow flex-column gap-4">
          <div class="flex gap-2">
            <div class="grow">
              <div class="lum-label">Date/Time Created</div>
              <div class="flex">
                {{ creditMemoDetails?.createdAt | date: 'MMM d, y, h:mm a' }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex grow flex-column gap-4">
          <div class="flex gap-2">
            <div class="grow">
              <div class="lum-label">Credit Memo Amount</div>
              <div class="flex">
                {{ creditMemoDetails?.creditMemo | currency }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex grow flex-column gap-4">
          <div class="flex gap-2">
            <div class="grow">
              <div class="lum-label">Used Amount</div>
              <div class="flex">
                {{ creditMemoDetails?.usedAmount | currency }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex grow flex-column gap-4">
          <div class="flex gap-2">
            <div class="grow">
              <div class="lum-label">Balance / Available Amount</div>
              <div class="flex">
                {{ creditMemoDetails?.balanceAmount | currency }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <div class="flex">
    <div class="grow">
      <lum-credit-memo-invoice-table
        *ngIf="creditMemoDetails?.paymentLogs"
        [creditMemoPaymentLogs]="creditMemoDetails?.paymentLogs || []"
      ></lum-credit-memo-invoice-table>
    </div>
  </div>
</div>
